import { commandItemIconClass } from "@/components/command-palette/constants";
import { CommandGroup, CommandItem } from "@/components/flexkit/Command";
import {
    parseAsUserSettingsTab,
    USER_SETTINGS_MODAL_QUERY_PARAM,
    type UserSettingsTab,
} from "@/components/settings/user-settings-constants";
import { IconBranch } from "central-icons/IconBranch";
import { IconCirclePerson } from "central-icons/IconCirclePerson";
import { IconKey1 } from "central-icons/IconKey1";
import { IconKey2 } from "central-icons/IconKey2";
import { IconPuzzle } from "central-icons/IconPuzzle";
import { IconTestTube } from "central-icons/IconTestTube";
import { useQueryState } from "nuqs";
import { useCallback, type FC, type ReactNode } from "react";

// Matches the tabs array in UserSettingsModal.tsx — keep in sync.
const userSettingsTabs: { id: UserSettingsTab; label: string; icon: ReactNode }[] = [
    { id: "profile", label: "Account", icon: <IconCirclePerson /> },
    { id: "secrets", label: "Secrets", icon: <IconKey1 /> },
    { id: "git-authentications", label: "Git authentications", icon: <IconBranch /> },
    { id: "personal-access-tokens", label: "Personal access tokens", icon: <IconKey2 /> },
    { id: "integrations", label: "Integrations", icon: <IconPuzzle /> },
    { id: "experiments", label: "Experiments", icon: <IconTestTube /> },
];

type UserSettingsPageProps = {
    runCommand: (fn: () => void) => void;
};

export const UserSettingsPage: FC<UserSettingsPageProps> = ({ runCommand }) => {
    const [, setUserSettingsTab] = useQueryState(USER_SETTINGS_MODAL_QUERY_PARAM, parseAsUserSettingsTab);

    const handleSelect = useCallback(
        (tabId: UserSettingsTab) => {
            runCommand(() => {
                void setUserSettingsTab(tabId);
            });
        },
        [runCommand, setUserSettingsTab],
    );

    return (
        <CommandGroup heading="User Settings">
            {userSettingsTabs.map((tab) => (
                <CommandItem key={tab.id} value={tab.label} onSelect={() => handleSelect(tab.id)}>
                    <span className={commandItemIconClass}>{tab.icon}</span>
                    <span>{tab.label}</span>
                </CommandItem>
            ))}
        </CommandGroup>
    );
};
